<template>
  <div class="fill-height">
    <SignInWindow @afterSignIn="afterSignIn"/>
  </div>
</template>

<script>
import SignInWindow from "@/components/Auth/SignInWindow";

export default {
  components: {SignInWindow},
  methods: {
    afterSignIn() {
      if (this.$route.query.afterLogin) {
        this.$router.push({name: this.$route.query.afterLogin})
      } else {
        this.$router.push({name: "dashboard"})
      }
    }
  },
  mounted() {
    const therapistId = this.$route.query.assign_therapist
    if (therapistId) {
      localStorage.setItem('assign_therapist', therapistId)
    }
  }
}
</script>

<style scoped>

</style>

